import { debounce } from 'lodash'
import { useEffect, useMemo, useRef } from 'react'

export const useDebounceSearch = ({
  onSearch,
  searchQuery,
  delay = 800,
}: {
  onSearch: (searchQuery?: string | object) => void
  searchQuery?: string | object
  delay?: number
}) => {
  const onSearchRef = useRef(onSearch)

  const debouncedSearch = useMemo(
    () =>
      debounce((query: string | object) => {
        onSearchRef.current(query)
      }, delay),
    [],
  )

  // Always keep latest function
  useEffect(() => {
    onSearchRef.current = onSearch
  }, [onSearch])

  useEffect(() => {
    if (searchQuery !== undefined) {
      debouncedSearch(searchQuery)
    }

    return () => {
      debouncedSearch.cancel()
    }
  }, [searchQuery, debouncedSearch])
}

export const handleQuery = (searchFunction: () => void) => {
  searchFunction()
}

export const handleDebouncedQuery = debounce(handleQuery, 1000)

export const getDebouncedCall = (delay: number = 1000) =>
  debounce((searchFunction: () => void) => {
    searchFunction()
  }, delay)
